module.exports = __webpack_public_path__ + "static/media/phone-11-pro-back.8bb77d7b.png";